import script from "./DepartmentIntellectualTab.vue?vue&type=script&setup=true&lang=js"
export * from "./DepartmentIntellectualTab.vue?vue&type=script&setup=true&lang=js"

import "./DepartmentIntellectualTab.vue?vue&type=style&index=0&id=3173aa4c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3173aa4c"]])

export default __exports__